/* eslint-disable @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any */
var toString = Object.prototype.toString;
export function isPresent(value) {
    return value !== undefined && value !== null;
}
export function isUndefined(value) {
    return typeof value === 'undefined';
}
export function isDefined(value) {
    return typeof value !== 'undefined';
}
// http://jsperf.com/isobject4
export function isObject(value) {
    return value !== null && typeof value === 'object';
}
export function isString(value) {
    return typeof value === 'string';
}
export function isNumber(value) {
    return typeof value === 'number';
}
export var isNaN = isFunction(Number.isNaN)
    ? Number.isNaN
    : function (num) { return num !== num; };
export function isDate(value) {
    return toString.call(value) === '[object Date]';
}
export function isArray(value) {
    return Array.isArray(value);
}
export function isError(value) {
    var tag = toString.call(value);
    switch (tag) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return value instanceof Error;
    }
}
export function isErrorEvent(value) {
    return toString.call(value) === '[object ErrorEvent]';
}
export function isFunction(value) {
    return typeof value === 'function';
}
export function isRegExp(value) {
    return toString.call(value) === '[object RegExp]';
}
export function isText(value) {
    return typeof value === 'string' && value !== '';
}
export function isBoolean(value) {
    return typeof value === 'boolean';
}
export function isWindow(value) {
    return isObject(value) && value.window === value;
}
export function isFile(value) {
    return toString.call(value) === '[object File]';
}
export function isFormData(value) {
    return toString.call(value) === '[object FormData]';
}
export function isBlob(value) {
    return toString.call(value) === '[object Blob]';
}
export function isPromiseLike(obj) {
    return isObject(obj) && isFunction(obj.then);
}
export function isArrayBuffer(obj) {
    return toString.call(obj) === '[object ArrayBuffer]';
}
var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
export function isTypedArray(value) {
    return isObject(value) && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}
//# sourceMappingURL=index.js.map